import React from 'react';
import { IPackProgressStatisticsType } from '../actions/StatsActions';
import SolidGaugeChart, { ISolidGaugeChartDataItem } from './charts/SolidGaugeChart';
import * as am4core from "@amcharts/amcharts4/core";

export interface IUserPackProgressChartsProps {
  data: IPackProgressStatisticsType
}

const UserPackProgressCharts: React.FC<IUserPackProgressChartsProps> = (props: IUserPackProgressChartsProps) => {
    let colors: am4core.Color[] = [
        am4core.color("#7D00F5"),
        am4core.color("#058AE5"),
        am4core.color("#00B593"),
        am4core.color("#8ACC66"),
        am4core.color("#661A2E"),
      ];

    let singlesData: ISolidGaugeChartDataItem[] = [];
    let doublesData: ISolidGaugeChartDataItem[] = [];
    
    if (props.data) {
        singlesData = [
            {
                category: "99+%",
                value: props.data.singlesChartsPurpleAwardCount,
                maxValue: props.data.totalSinglesChartsCount,
                color: colors[0],
            },
            {
                category: "98+%",
                value: props.data.singlesChartsBlueAwardCount,
                maxValue: props.data.totalSinglesChartsCount,
                color: colors[1],
            },
            {
                category: "96+%",
                value: props.data.singlesChartsGreenAwardCount,
                maxValue: props.data.totalSinglesChartsCount,
                color: colors[2],
            },
            {
                category: "90+%",
                value: props.data.singlesChartsYellowAwardCount,
                maxValue: props.data.totalSinglesChartsCount,
                color: colors[3],
            },
            {
                category: "Passed",
                value: props.data.singlesChartsRedAwardCount,
                maxValue: props.data.totalSinglesChartsCount,
                color: colors[4],
            },
        ]
    
        doublesData = [
            {
                category: "99+%",
                value: props.data.doublesChartsPurpleAwardCount,
                maxValue: props.data.totalDoublesChartsCount,
                color: colors[0],
            },
            {
                category: "98+%",
                value: props.data.doublesChartsBlueAwardCount,
                maxValue: props.data.totalDoublesChartsCount,
                color: colors[1],
            },
            {
                category: "96+%",
                value: props.data.doublesChartsGreenAwardCount,
                maxValue: props.data.totalDoublesChartsCount,
                color: colors[2],
            },
            {
                category: "90+%",
                value: props.data.doublesChartsYellowAwardCount,
                maxValue: props.data.totalDoublesChartsCount,
                color: colors[3],
            },
            {
                category: "Passed",
                value: props.data.doublesChartsRedAwardCount,
                maxValue: props.data.totalDoublesChartsCount,
                color: colors[4],
            },
        ]
    }

    if (props.data.totalSinglesChartsCount > 0 && props.data.totalDoublesChartsCount > 0) {
        return (
            <div className="UserPackProgressCharts">
                <table className="ProfileChartsTable">
                    <tr>
                        <td>Score Completionist View for {props.data.packName} (Singles)</td>
                        <td>Score Completionist View for {props.data.packName} (Doubles)</td>
                    </tr>
                    <tr>
                        <td><SolidGaugeChart id="PackSinglesSolidGaugeChart" title="Singles" data={singlesData} /></td>
                        <td><SolidGaugeChart id="PackDoublesSolidGaugeChart" title="Doubles" data={doublesData} /></td>
                    </tr>
                </table>
            </div>
        );
    }
    else if (props.data.totalSinglesChartsCount > 0) {
        return (
            <div className="UserPackProgressCharts">
                <table className="ProfileChartsTable">
                    <tr>
                        <td>Score Completionist View for {props.data.packName} (Singles)</td>
                    </tr>
                    <tr>
                        <td><SolidGaugeChart id="PackSinglesSolidGaugeChart" title="Singles" data={singlesData} /></td>
                    </tr>
                </table>
            </div>
        );
    }
    else if (props.data.totalDoublesChartsCount > 0) {
        return (
            <div className="UserPackProgressCharts">
                <table className="ProfileChartsTable">
                    <tr>
                        <td>Score Completionist View for {props.data.packName} (Doubles)</td>
                    </tr>
                    <tr>
                        <td><SolidGaugeChart id="PackDoublesSolidGaugeChart" title="Doubles" data={doublesData} /></td>
                    </tr>
                </table>
            </div>
        );
    }
    else {
        return (
            <div className="UserPackProgressCharts">
                <table className="ProfileChartsTable">
                </table>
            </div>
        );
    }
    
  }
  
  export default UserPackProgressCharts;